module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "abbrs"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pviii"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pix"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/ChiLeong0006#toc"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "border-bottom": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("BL")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("British Library, London")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("Bodleian")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Bodleian Library, Oxford")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("CUL")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Cambridge University Library, Cambridge")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("Folger")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Folger Shakespeare Library, Washington, DC")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("Glasgow")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Glasgow University Library, Glasgow")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("Huntington")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Henry E. Huntington Library, San Marino, California")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("NLM")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("National Library of Medicine, Bethesda, Maryland")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("NYAM")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("New York Academy of Medicine Library, New York City, New York")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("NYPL")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("New York Public Library, New York City, New York")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_c('i', [_vm._v("OED")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Oxford English Dictionary Online")]), _vm._v(", ed. J. Simpson and E. Weiner (Oxford, 2003)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_c('i', [_vm._v("Oxford DNB")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Oxford Dictionary of National Biography Online")]), _vm._v(", ed. H. C. G. Matthew and B. Harrison (Oxford, 2004)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("RCP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Royal College of Physicians Library, London")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("RCS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Royal College of Surgeons Library, London")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_c('i', [_vm._v("STC")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("A. W. Pollard and G. R. Redgrave, "), _c('i', [_vm._v("A Short-Title Catalogue of Books Printed in England, Scotland, and Ireland and of English Books Printed Abroad, 1475–1640")]), _vm._v(", 2nd ed., rev. by K. F. Pantzer, 3 vols. (London, 1976–91)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("Wellcome")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Wellcome Library for the History and Understanding of Medicine, London")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_c('i', [_vm._v("Wing")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("D. Wing, "), _c('i', [_vm._v("Short-Title Catalogue of Books Printed in England, Scotland, Ireland, Wales and British America and of English Books Printed in Other Countries, 1641–1700")]), _vm._v(", 2nd ed., 3 vols. (New York: Index Committee of the Modern Language Association of America, 1972–94)")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e66f2bb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chi-Leong-0007.vue
// module id = 72
// module chunks = 0